import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CustomButton from 'component/Shared/Button';
import PopperComp from './PopperComp';

// date picker
import { DateComp } from './DateComp';
import TimeComp from './TimeComp';




const TaskPopup = () => {
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

// popper state

const [popper, setPopper] = React.useState({
  open1: false,
  open2: false,
  anchorEl1: null,
  anchorEl2: null,
  placement1: '',
  placement2: ''
});
  // const [open1, setOpen1] = React.useState(false);
  // const [anchorEl, setAnchorEl] = React.useState(null);
  // const [placement, setPlacement] = React.useState();

  const handleClick = (newPlacement, popperKey) => (event) => {
    setPopper((prevState) => ({
      ...prevState,
      [`anchorEl${popperKey}`]: event.currentTarget,
      [`open${popperKey}`]: prevState[`placement${popperKey}`] !== newPlacement || !prevState[`open${popperKey}`],
      [`placement${popperKey}`]: newPlacement
    }));
  };

  const canBeOpen = open && Boolean(setPopper.anchorEl1 && setPopper.anchorEl2);
  const id1 = canBeOpen ? 'transition-popper1' : undefined;
  const id2 = canBeOpen ? 'transition-popper2' : undefined;





  return (
    <React.Fragment>
      <Button variant="outlined" onClick={handleClickOpen}>
        Add Task
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          component: 'form',
          onSubmit: (event) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries((formData).entries());
            const email = formJson.email;
            console.log(email);
            handleClose();
          },
        }}
      >
        <DialogTitle sx={{ marginBottom: "-20px" }}>Add Task</DialogTitle>
        <DialogContent>
          <TextField autoFocus required margin="dense" id="name" name="Task Name" label="Enter Task Name"
            type="email" fullWidth variant="standard" />
          <TextField autoFocus required margin="dense" id="name" name="" label="Enter Description"
            type="email" fullWidth variant="standard" />
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", gap: "10px;", wrap: "wrap" }}>
          <CustomButton children="Due Date" aria-describedby={id1} type="button" onClick={handleClick('left',1)} />
           
          <CustomButton children="Due Time" aria-describedby={id2} type="button" onClick={handleClick('left',2)} />
          <CustomButton children="Priority" />
          <CustomButton children="Reminder" />
        </DialogActions>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="submit">Add Task</Button>
        </DialogActions>
      </Dialog>


      <PopperComp children={<DateComp label={'Due Date'} />} id={id1} open={popper.open1} anchorEl={popper.anchorEl1} />
      <PopperComp children={<TimeComp />} id={id2} open={popper.open2} anchorEl={popper.anchorEl2} />
    
    </React.Fragment>
  );
}

export default TaskPopup;